import { createSlice } from "@reduxjs/toolkit";

import {
  getGstThreebInvoiceListAction,
  getGstrTwoAReturnsListAction,
  getGstrOneInvoiceListAction,
  getGstrOneListAction,
  getGstrOnehsnWiseCountAction,
  getGstrThreeBListAction,
  getInwardsListAction,
  getOutwardsListAction,
  requestGstOtpAction,
  updateInwardsListAction,
  updateOutwardListAction,
  verifyGstOtpAction,
  getGstrTwoBReturnsListAction,
  postGstrOneFilingSaveDataAction,
  postGstrOneFilingSendOTPAction,
  postGstrOneCompleteFilingAction,
  // gstOneProceesFileAction,
  getGstNumberList,
  approveGstAction,
  gstPostCommentAction,
  gstGetAllCommentAction,
  postGstrThreeBFilingMappingAction,
  gstOneProceedFileAction,
  postGstrOneFilingResetSaveDataAction,
  gstOneFilingStatus,
  getGstrTwoATwoBCompareListAction,
  postARNNumberAction,
  updateInwardGstr2a2bStatusAction,
  getGstr2a2bSyncStatusAction,
  getAdminGstr1FilingReportAction,
  getAdminGstr3bFilingReportAction,
  getGstrThreeBDetailsAction,
  postGstrThreeBFilingSaveDataAction,
  postGstrThreeBFilingCompleteFilingAction,
  getGstrThreeBFilingStatusAction,
  getGstr3BCashItcBalanceAction,
  postSaveCinNumberAction,
  getGstNoticesListAction,
  getGstNoticeDetailsAction,
} from "@/redux/gstModule/action";
import type { GstModuleTypes } from "@/redux/gstModule/gstModuleTypes";
import { initialState } from "@/redux/gstModule/initialState";
import { gstModuleReducer } from "@/redux/gstModule/reducer";

export const gstModuleSlice = createSlice({
  name: "gstModule",
  initialState,
  reducers: gstModuleReducer,
  extraReducers(builder) {
    builder
      .addCase(getOutwardsListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        getOutwardsListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const {
            status_code,
            success,
            result,
            message,
            total_count,
            total_cgst_amount,
            total_igst_amount,
            total_invoice_value,
            total_sgst_amount,
            total_taxable_value,
          } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            outwardsData: result,
            totalOutwardsListCount: total_count,
            totalCgstAmount: total_cgst_amount,
            totalIgstAmount: total_igst_amount,
            totalInvoiceValue: total_invoice_value,
            totalSgstAmount: total_sgst_amount,
            totalTaxableValue: total_taxable_value,
          };
        }
      )
      .addCase(
        getOutwardsListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(updateOutwardListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        // fetching: true
      }))
      .addCase(
        updateOutwardListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            success,
            statusCode: status_code,
            message,
          };
        }
      )
      .addCase(
        updateOutwardListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(getInwardsListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        getInwardsListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const {
            status_code,
            success,
            result,
            message,
            total_count,
            total_cgst_amount,
            total_igst_amount,
            total_invoice_value,
            total_sgst_amount,
            total_taxable_value,
            total_itc_amount,
            last_sync_at,
          } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            inwardsData: result,
            totalInwardsListCount: total_count,
            totalCgstAmount: total_cgst_amount,
            totalIgstAmount: total_igst_amount,
            totalInvoiceValue: total_invoice_value,
            totalSgstAmount: total_sgst_amount,
            totalTaxableValue: total_taxable_value,
            totalItcAmount: total_itc_amount,
            lastSyncAt: last_sync_at,
          };
        }
      )
      .addCase(
        getInwardsListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(updateInwardsListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        // fetching: true
      }))
      .addCase(
        updateInwardsListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            success,
            statusCode: status_code,
            message,
          };
        }
      )
      .addCase(
        updateInwardsListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(getGstrOneListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        getGstrOneListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrOneData: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstrOneListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )

      .addCase(
        getGstrOneInvoiceListAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrOneInvoiceListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrOneInvoiceList: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstrOneInvoiceListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getGstThreebInvoiceListAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstThreebInvoiceListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrThreeBInvoiceList: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstThreebInvoiceListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getGstrOnehsnWiseCountAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrOnehsnWiseCountAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            getGstrOnehsnWiseList: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstrOnehsnWiseCountAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(getGstrThreeBListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        getGstrThreeBListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrThreeBData: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstrThreeBListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getGstrTwoAReturnsListAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrTwoAReturnsListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const {
            status_code,
            success,
            result,
            message,
            total_count,
            fetch_from_gst_portal,
          } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrTwoAReturnsData: result,
            success,
            message,
            fetchFromGstPortal: fetch_from_gst_portal,
          };
        }
      )
      .addCase(
        getGstrTwoAReturnsListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getGstrTwoBReturnsListAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrTwoBReturnsListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const {
            status_code,
            success,
            result,
            message,
            total_count,
            fetch_from_gst_portal,
          } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrTwoBReturnsData: result,
            success,
            message,
            fetchFromGstPortal: fetch_from_gst_portal,
          };
        }
      )
      .addCase(
        getGstrTwoBReturnsListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(requestGstOtpAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstOtpFetching: true,
        gstOtpRequestFetching: true,
      }))
      .addCase(
        requestGstOtpAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              gstOtpStatusCode: status_code,
              gstOtpError: message,
              gstOtpFetching: false,
              gstOtpRequestFetching: false,
            };
          }

          return {
            ...state,
            success: 1,
            gstOtpStatusCode: status_code,
            gstOtpMessage: message,
            gstOtpFetching: false,
            gstOtpRequestFetching: false,
          };
        }
      )
      .addCase(
        requestGstOtpAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstOtpFetching: false,
          gstOtpRequestFetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(verifyGstOtpAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstOtpFetching: true,
        gstOtpVerifyFetching: true,
      }))
      .addCase(
        verifyGstOtpAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;
          if (success === 0) {
            return {
              ...state,
              success,
              // statusCode: status_code,
              gstOtpVerifyError: message,
              gstOtpFetching: false,
              gstOtpVerifyFetching: false,
            };
          }

          return {
            ...state,
            success: 1,
            // statusCode: status_code,
            gstOtpVerifyMessage: message,
            gstOtpFetching: false,
            gstOtpVerifyFetching: false,
          };
        }
      )
      .addCase(
        verifyGstOtpAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstOtpFetching: false,
          gstOtpVerifyFetching: false,
          error: error?.message,
          success: 0,
        })
      )

      //////gstrFilling

      .addCase(
        postGstrOneFilingSaveDataAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstFilingFetching: true,
          // fetching:true
        })
      )
      .addCase(
        postGstrOneFilingSaveDataAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstFilingSuccess: success,
              success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.data?.error?.message
                ? result?.data?.error?.error_cd +
                  ": " +
                  result?.data?.error?.message
                : result?.Summary?.data?.error?.message
                  ? result?.Summary?.data?.error?.error_cd +
                    ": " +
                    result?.Summary?.data?.error?.message
                  : result?.error?.message
                    ? result?.error?.message
                    : result?.error
                      ? result?.error
                      : message,
              gstFilingFetching: false,
              // fetching:false,
              error: message,
              gstFilingMessage: message,
              statusCode: status_code,
            };
          }

          return {
            ...state,
            gstFilingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            gstFilingFetching: false,
            statusCode: status_code,
            numberOfInvoices: result?.number_of_invoices,
            numberOfEInvoices: result?.number_of_einvoice,
            numberOfUploadInvoices: result?.total_uploaded_invoices,
          };
        }
      )
      .addCase(
        postGstrOneFilingSaveDataAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstFilingFetching: false,
          // gstFillingError: error?.message,
          gstFilingSuccess: 0,
          success: 0,
          error: error?.message,
          gstFilingError: error?.message,
        })
      )
      ///reset gstr one data
      .addCase(
        postGstrOneFilingResetSaveDataAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstFilingFetching: true,
          fetching: true,
        })
      )
      .addCase(
        postGstrOneFilingResetSaveDataAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstFilingSuccess: success,
              success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.data?.error?.message
                ? result?.data?.error?.message
                : result?.error?.message
                  ? result?.error?.message
                  : result?.error
                    ? result?.error
                    : message,
              gstFilingFetching: false,
              fetching: false,
              error: message,
              gstFilingMessage: message,
              statusCode: status_code,
            };
          }

          return {
            ...state,
            gstFilingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            gstFilingFetching: false,
            statusCode: status_code,
            fetching: false,
          };
        }
      )
      .addCase(
        postGstrOneFilingResetSaveDataAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstFilingFetching: false,
          // gstFillingError: error?.message,
          gstFilingSuccess: 0,
          success: 0,
          error: error?.message,
          fetching: false,
        })
      )

      /////threeb filing Mapping
      .addCase(
        postGstrThreeBFilingMappingAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstFilingFetching: true,
          // fetching:true
        })
      )
      .addCase(
        postGstrThreeBFilingMappingAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstFilingSuccess: success,
              success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.errors,
              gstFilingFetching: false,
              // fetching:false,
              error: message,
              gstFilingMessage: message,
              statusCode: status_code,
            };
          }

          return {
            ...state,
            gstFilingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            gstFilingFetching: false,
            statusCode: status_code,
          };
        }
      )
      .addCase(
        postGstrThreeBFilingMappingAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstFilingFetching: false,
          // gstFillingError: error?.message,
          gstFilingSuccess: 0,
          success: 0,
          error: error?.message,
        })
      )

      .addCase(
        postGstrOneFilingSendOTPAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        postGstrOneFilingSendOTPAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              //  gstFilingSuccess: success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.data?.error?.message
                ? result?.data?.error?.message
                : result?.error?.message
                  ? result?.error?.message
                  : result?.OTP?.data?.error?.message
                    ? result?.OTP?.data?.error?.message
                    : message,
              fetching: false,
              gstFilingMessage: message,
            };
          }

          return {
            ...state,
            // gstFilingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            fetching: false,
          };
        }
      )
      .addCase(
        postGstrOneFilingSendOTPAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          gstFilingError: error?.message,
          // gstFilingSuccess: 0,
          success: 0,
        })
      )

      .addCase(
        postGstrOneCompleteFilingAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        postGstrOneCompleteFilingAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              //  gstFilingSuccess: success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.error?.message
                ? result?.error?.message
                : result?.data?.error?.message
                  ? result?.data?.error?.message
                  : message,
              fetching: false,
              gstFilingMessage: message,
            };
          }

          return {
            ...state,
            // gstFilingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            fetching: false,
            gstOneFilingACKNumber: result?.data?.data?.ack_num,
          };
        }
      )
      .addCase(
        postGstrOneCompleteFilingAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          gstFilingError: error?.message,
          // gstFillingSuccess: 0,
          success: 0,
        })
      )

      .addCase(gstOneProceedFileAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        gstOneProceedFileAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              success,
              //  gstFillingSuccess: success,
              gstFilingStatusCode: status_code,
              gstFilingError: result?.data?.error?.message
                ? result?.data?.error?.message
                : result?.summary?.data?.error?.message
                  ? result?.summary?.data?.error?.message
                  : result?.error?.message
                    ? result?.error?.message
                    : result?.error
                      ? result?.error
                      : message,
              fetching: false,
              gstFilingMessage: message,
            };
          }

          return {
            ...state,
            // gstFillingSuccess: 1,
            success,
            gstFilingStatusCode: status_code,
            gstFilingMessage: message,
            fetching: false,
          };
        }
      )
      .addCase(
        gstOneProceedFileAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          gstFilingError: error?.message,
          // gstFillingSuccess: 0,
          success: 0,
        })
      )

      ///gst number
      .addCase(getGstNumberList.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        getGstNumberList.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstNumberList: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstNumberList.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(approveGstAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        approveGstAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            approvalSuccess: success,
            success,
            message,
          };
        }
      )
      .addCase(
        approveGstAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )

      .addCase(gstPostCommentAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        gstPostCommentAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstCommentSuccess: success,
            message,
          };
        }
      )
      .addCase(
        gstPostCommentAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(gstGetAllCommentAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        gstGetAllCommentAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstCommentData: result,
            statusCode: status_code,
          };
        }
      )
      .addCase(
        gstGetAllCommentAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(gstOneFilingStatus.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        gstOneFilingStatus.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              gstOneFilingStatusSuccess: success,
              gstOneFilingStatusStatusCode: status_code,
              gstOneFilingStatusError: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstOneFilingStatus: result,
            gstOneFilingStatusSuccess: success,
            gstOneFilingStatusMessage: message,
          };
        }
      )
      .addCase(
        gstOneFilingStatus.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          gstOneFilingStatusError: error?.message,
          gstOneFilingStatusSuccess: 0,
        })
      )
      .addCase(
        getGstrTwoATwoBCompareListAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrTwoATwoBCompareListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrTwoBReturnsData: result,
            gstrTwoAReturnsData: result,
            success,
            message,
          };
        }
      )
      .addCase(
        getGstrTwoATwoBCompareListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      ////
      .addCase(postARNNumberAction.pending, (state: GstModuleTypes) => ({
        ...state,
        fetching: true,
      }))
      .addCase(
        postARNNumberAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message, total_count } =
            payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            success,
            message,
          };
        }
      )
      .addCase(
        postARNNumberAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        updateInwardGstr2a2bStatusAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          inwardGstr2a2bStatusResultFetching: true,
        })
      )
      .addCase(
        updateInwardGstr2a2bStatusAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              inwardGstr2a2bStatusResultFetching: false,
              success,
              statusCode: status_code,
              error: message,
              message,
              inwardGstr2a2bStatusResult: result ?? {},
            };
          }

          return {
            ...state,
            inwardGstr2a2bStatusResultFetching: false,
            success,
            statusCode: status_code,
            message,
            inwardGstr2a2bStatusResult: result ?? {},
          };
        }
      )
      .addCase(
        updateInwardGstr2a2bStatusAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          inwardGstr2a2bStatusResultFetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getGstr2a2bSyncStatusAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstr2a2bSyncStatusFetching: true,
        })
      )
      .addCase(
        getGstr2a2bSyncStatusAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstr2a2bSyncStatusFetching: false,
              success,
              statusCode: status_code,
              error: message,
              gstr2a2bSyncStatusJobResult: null,
            };
          }

          return {
            ...state,
            gstr2a2bSyncStatusFetching: false,
            success,
            statusCode: status_code,
            message,
            gstr2a2bSyncStatusJobResult: result ?? null,
            error: null,
          };
        }
      )
      .addCase(
        getGstr2a2bSyncStatusAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstr2a2bSyncStatusFetching: false,
          error: error?.message,
          success: 0,
          gstr2a2bSyncStatusJobResult: null,
        })
      )
      .addCase(
        getAdminGstr1FilingReportAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          adminGstr1FilingReportFetching: true,
        })
      )
      .addCase(
        getAdminGstr1FilingReportAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              adminGstr1FilingReportFetching: false,
              success,
              statusCode: status_code,
              error: message,
              adminGstr1FilingReport: null,
            };
          }

          return {
            ...state,
            adminGstr1FilingReportFetching: false,
            success,
            statusCode: status_code,
            message,
            adminGstr1FilingReport: result ?? null,
          };
        }
      )
      .addCase(
        getAdminGstr1FilingReportAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          adminGstr1FilingReportFetching: false,
          error: error?.message,
          success: 0,
          adminGstr1FilingReport: null,
        })
      )
      .addCase(
        getAdminGstr3bFilingReportAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          adminGstr3bFilingReportFetching: true,
        })
      )
      .addCase(
        getAdminGstr3bFilingReportAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              adminGstr3bFilingReportFetching: false,
              success,
              statusCode: status_code,
              error: message,
              adminGstr3bFilingReport: null,
            };
          }

          return {
            ...state,
            adminGstr3bFilingReportFetching: false,
            success,
            statusCode: status_code,
            message,
            adminGstr3bFilingReport: result ?? null,
          };
        }
      )
      .addCase(
        getAdminGstr3bFilingReportAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          adminGstr3bFilingReportFetching: false,
          error: error?.message,
          success: 0,
          adminGstr3bFilingReport: null,
        })
      )
      .addCase(getGstrThreeBDetailsAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstrThreeBFilingFetching: true,
      }))
      .addCase(
        getGstrThreeBDetailsAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message } = payload;

          if (success === 0) {
            return {
              ...state,
              gstrThreeBFilingFetching: false,
              gstrThreeBFilingSuccess: success,
              gstrThreeBFilingStatusCode: status_code,
              gstrThreeBFilingError: result?.data ? result?.data : message,
            };
          }

          return {
            ...state,
            gstrThreeBFilingFetching: false,
            gstrThreeBFiling: result,
            gstrThreeBFilingSuccess: success,
            gstrThreeBFilingStatusCode: status_code,
            gstrThreeBFilingMessage: message,
          };
        }
      )
      .addCase(
        getGstrThreeBDetailsAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstrThreeBFilingFetching: false,
          gstrThreeBFilingError: error?.message,
          gstrThreeBFilingSuccess: 0,
        })
      )
      .addCase(
        postGstrThreeBFilingSaveDataAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstrThreeBFilingFetching: true,
        })
      )
      .addCase(
        postGstrThreeBFilingSaveDataAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, result, message } = payload;

          if (success === 0) {
            return {
              ...state,
              gstrThreeBFilingFetching: false,
              gstrThreeBFilingSuccess: success,
              gstrThreeBFilingStatusCode: status_code,
              gstrThreeBFilingError: result?.error ? result?.error : message,
            };
          }

          return {
            ...state,
            gstrThreeBFilingFetching: false,
            gstrThreeBFilingSaveDataResult: result,
            gstrThreeBFilingSuccess: success,
            gstrThreeBFilingStatusCode: status_code,
            gstrThreeBFilingMessage: message,
          };
        }
      )
      .addCase(
        postGstrThreeBFilingSaveDataAction.rejected,
        (state: GstModuleTypes, { error, payload }) => {
          const rejectedPayload: any = payload;
          return {
            ...state,
            gstrThreeBFilingFetching: false,
            gstrThreeBFilingError: rejectedPayload?.message ?? error?.message,
            gstrThreeBFilingStatusCode:
              rejectedPayload?.status_code ?? state.gstrThreeBFilingStatusCode,
            gstrThreeBFilingSuccess: 0,
          };
        }
      )
      .addCase(
        postGstrThreeBFilingCompleteFilingAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstrThreeBFilingFetching: true,
        })
      )
      .addCase(
        postGstrThreeBFilingCompleteFilingAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstrThreeBFilingSuccess: success,
              gstrThreeBFilingStatusCode: status_code,
              gstrThreeBFilingError: result?.error?.message
                ? result?.error?.message
                : result?.data?.error?.message
                  ? result?.data?.error?.message
                  : message,
              gstrThreeBFilingFetching: false,
              gstrThreeBFilingMessage: message,
            };
          }

          return {
            ...state,
            gstrThreeBFilingSuccess: success,
            gstrThreeBFilingStatusCode: status_code,
            gstrThreeBFilingMessage: message,
            gstrThreeBFilingFetching: false,
            gstrThreeBFilingACKNumber: result?.data?.data?.ack_num,
          };
        }
      )
      .addCase(
        postGstrThreeBFilingCompleteFilingAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstrThreeBFilingFetching: false,
          gstrThreeBFilingError: error?.message,
          gstrThreeBFilingSuccess: 0,
        })
      )

      // gstr3B filing status
      .addCase(
        getGstrThreeBFilingStatusAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getGstrThreeBFilingStatusAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              gstrThreeBFilingStatusSuccess: success,
              gstrThreeBFilingStatusStatusCode: status_code,
              gstrThreeBFilingStatusError: message,
            };
          }

          return {
            ...state,
            fetching: false,
            gstrThreeBFilingStatusData: result,
            gstrThreeBFilingStatusSuccess: success,
            gstrThreeBFilingStatusMessage: message,
          };
        }
      )
      .addCase(
        getGstrThreeBFilingStatusAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          fetching: false,
          gstrThreeBFilingStatusError: error?.message ?? null,
          gstrThreeBFilingStatusSuccess: 0,
        })
      )

      // gstr3B cash & itc balance
      .addCase(
        getGstr3BCashItcBalanceAction.pending,
        (state: GstModuleTypes) => ({
          ...state,
          gstrThreeBFilingFetching: true,
        })
      )
      .addCase(
        getGstr3BCashItcBalanceAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message, result } = payload;

          if (success === 0) {
            return {
              ...state,
              gstrThreeBFilingFetching: false,
              gstrThreeBFilingSuccess: success,
              gstrThreeBFilingStatusCode: status_code,
              gstrThreeBFilingError: message,
            };
          }

          return {
            ...state,
            gstrThreeBFilingFetching: false,
            gstr3BCashItcBalance: result?.data?.data,
            gstrThreeBFilingSuccess: success,
            gstrThreeBFilingStatusCode: status_code,
            gstrThreeBFilingMessage: message,
          };
        }
      )
      .addCase(
        getGstr3BCashItcBalanceAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstrThreeBFilingFetching: false,
          gstrThreeBFilingError: error?.message,
          gstrThreeBFilingSuccess: 0,
        })
      )

      // gstr3B save CIN number
      .addCase(postSaveCinNumberAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstrThreeBFilingFetching: true,
      }))
      .addCase(
        postSaveCinNumberAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              gstrThreeBFilingFetching: false,
              gstrThreeBFilingSuccess: success,
              gstrThreeBFilingStatusCode: status_code,
              gstrThreeBFilingError: message,
            };
          }

          return {
            ...state,
            gstrThreeBFilingFetching: false,
            gstrThreeBFilingSuccess: success,
            gstrThreeBFilingStatusCode: status_code,
            gstrThreeBFilingMessage: message,
          };
        }
      )
      .addCase(
        postSaveCinNumberAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstrThreeBFilingFetching: false,
          gstrThreeBFilingError: error?.message,
          gstrThreeBFilingSuccess: 0,
        })
      )

      // gst notices list
      .addCase(getGstNoticesListAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstNoticesListFetching: true,
        gstNoticesListError: null,
      }))
      .addCase(
        getGstNoticesListAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              gstNoticesListFetching: false,
              gstNoticesListStatusCode: status_code,
              gstNoticesListError: message,
              gstNoticesList: [],
            };
          }

          const notices =
            payload?.data?.notices ??
            payload?.result?.data?.notices ??
            payload?.result?.notices ??
            payload?.notices ??
            [];

          return {
            ...state,
            gstNoticesListFetching: false,
            gstNoticesListStatusCode: status_code ?? null,
            gstNoticesList: notices,
            gstNoticeDetailsMessage: message,
          };
        }
      )
      .addCase(
        getGstNoticesListAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstNoticesListFetching: false,
          gstNoticesListError: error?.message,
          gstNoticesList: [],
        })
      )

      // gst notice details
      .addCase(getGstNoticeDetailsAction.pending, (state: GstModuleTypes) => ({
        ...state,
        gstNoticeDetailsFetching: true,
        gstNoticeDetailsError: null,
      }))
      .addCase(
        getGstNoticeDetailsAction.fulfilled,
        (state: GstModuleTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              gstNoticeDetailsFetching: false,
              gstNoticeDetailsStatusCode: status_code,
              gstNoticeDetailsError: message,
              gstNoticeDetails: null,
            };
          }

          const details =
            payload?.data?.notice ??
            payload?.result?.data?.notice ??
            payload?.result?.notice ??
            payload?.result ??
            payload?.data ??
            payload?.notice ??
            null;

          const detailsWithMeta = details
            ? {
                ...details,
                ...(payload?.transaction_id && !details.transaction_id
                  ? { transaction_id: payload.transaction_id }
                  : {}),
                ...(payload?.timestamp && !details.timestamp
                  ? { timestamp: payload.timestamp }
                  : {}),
              }
            : null;

          return {
            ...state,
            gstNoticeDetailsFetching: false,
            gstNoticeDetailsStatusCode: status_code ?? null,
            gstNoticeDetails: detailsWithMeta,
          };
        }
      )
      .addCase(
        getGstNoticeDetailsAction.rejected,
        (state: GstModuleTypes, { error }) => ({
          ...state,
          gstNoticeDetailsFetching: false,
          gstNoticeDetailsError: error?.message,
          gstNoticeDetails: null,
        })
      );
  },
});
export const {
  resetGstModuleFetching,
  resetGstModuleSuccess,
  resetGstModuleError,
  resetGstMessage,
  resetOutwardsData,
  resetTotalOutwardsListCount,
  resetTotalInwardsListCount,
  resetInwardsData,
  resetGstrOneData,
  resetTotalCgstAmount,
  resetTotalIgstAmount,
  resetTotalInvoiceValue,
  resetTotalSgstAmount,
  resetTotalTaxableValue,
  resetTotalItcAmount,
  resetLastSyncAt,
  resetGstrInvoiceList,
  resetGstrOnehsnWiseList,
  resetGstrThreeBDataList,
  resetGstrThreeBInvoiceList,
  resetGstrTwoAReturnsData,
  resetGstrTwoBReturnsData,
  resetGstFilingError,
  resetGstFilingSuccess,
  resetGstFilingMessage,
  resetGstNumberList,
  resetGstCommentsSuccess,
  resetGstOtpError,
  resetGstOtpMessage,
  resetGstOtpVerifyError,
  resetGstOtpVerifyMessage,
  resetGstOtpFetching,
  resetGstOtpVerifyFetching,
  resetGstOtpRequestFetching,
  resetGstOneFilingACKNumber,
  resetNumberOfInvoices,
  resetGstOneFilingStatus,
  resetGstOneFilingStatusSuccess,
  resetGstOneFilingStatusError,
  resetGstOneFilingStatusMessage,
  resetGstOneFilingStatusStatusCode,
  resetInwardGstr2a2bStatusResult,
  resetGstr2a2bSyncStatusJobResult,
  resetGstr2a2bSyncStatusFetching,
  resetInwardGstr2a2bStatusResultFetching,
  resetAdminGstr1FilingReport,
  resetAdminGstr3bFilingReport,
  resetGstrThreeBFiling,
  resetGstrThreeBFilingSuccess,
  resetGstrThreeBFilingError,
  resetGstrThreeBFilingMessage,
  resetGstrThreeBFilingStatusCode,
  resetGstrThreeBFilingACKNumber,
  resetGstrThreeBFilingStatusData,
  resetGstrThreeBFilingStatusSuccess,
  resetGstrThreeBFilingStatusError,
  resetGstrThreeBFilingStatusMessage,
  resetGstrThreeBFilingStatusStatusCode,
  resetGstr3BCashItcBalance,
  resetGstNoticesList,
  resetGstNoticesListError,
  resetGstNoticeDetails,
  resetGstNoticeDetailsError,
} = gstModuleSlice.actions;
